var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestionMarkCircledSolid = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25 13C25 6.097 19.403.5 12.5.5S0 6.097 0 13s5.597 12.5 12.5 12.5S25 19.903 25 13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.905 19.5c-.325 0-.61-.114-.853-.34-.242-.225-.363-.541-.363-.948 0-.362.117-.664.351-.91.235-.247.523-.37.865-.37.335 0 .618.123.847.37.23.246.345.548.345.91 0 .4-.12.716-.36.945-.24.228-.517.343-.832.343M9 10.09c0-.544.162-1.096.488-1.653.325-.56.8-1.022 1.426-1.388.624-.365 1.351-.549 2.183-.549.771 0 1.456.153 2.048.46.592.305 1.05.722 1.372 1.248.322.528.483 1.1.483 1.718 0 .486-.09.913-.273 1.279a3.958 3.958 0 0 1-.658.949 47.92 47.92 0 0 1-1.364 1.344 6.026 6.026 0 0 0-.437.468 2.04 2.04 0 0 0-.243.37 1.89 1.89 0 0 0-.124.334c-.03.112-.075.308-.132.588-.102.596-.419.894-.953.894a.941.941 0 0 1-.7-.294c-.188-.194-.282-.482-.282-.866 0-.48.067-.897.206-1.248.14-.353.324-.662.552-.93.231-.266.539-.582.93-.947.34-.322.587-.563.738-.726.153-.163.282-.344.384-.546.105-.2.157-.418.157-.652 0-.457-.16-.845-.475-1.16-.319-.313-.728-.47-1.23-.47-.586 0-1.019.158-1.294.476-.28.317-.513.785-.706 1.402-.181.648-.525.972-1.031.972a.986.986 0 0 1-.759-.34c-.203-.227-.306-.47-.306-.733"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionMarkCircledSolid);
export default ForwardRef;